import { Link } from "react-router-dom";

import equityResearch from "@/assets/events/supc-2026/equity-research.webp";
import investmentStrategies from "@/assets/events/supc-2026/investment-strategies.webp";
import networking from "@/assets/events/supc-2026/networking.webp";
import panelDiscussion from "@/assets/events/women-in-business/panel-discussion.webp";
import carnegie from "@/assets/events/stockholm-banking-trip/carnegie.webp";
import tradingWorkshop from "@/assets/events/trading-workshop/equity-pitch-recap.webp";

const divisions = [
  {
    title: "Portfolio Management",
    desc: "Deploying capital across Nordic equities and alternative assets with a focus on long-term value.",
    image: investmentStrategies,
    link: "/activities?tab=archive#event-supc",
  },
  {
    title: "Equity Research",
    desc: "Rigorous fundamental analysis and sector-specific deep dives into listed companies.",
    image: equityResearch,
    link: "/insights?tab=research",
  },
  {
    title: "Events & Networking",
    desc: "Connecting students with top-tier investment banks and private equity firms.",
    image: networking,
    link: "/activities?tab=archive#event-banquet",
  },
  {
    title: "Women in Business",
    desc: "Empowering diversity in finance through dedicated programming and mentorship.",
    image: panelDiscussion,
    link: "/activities?tab=archive#event-women-in-business",
  },
  {
    title: "Banking Trips",
    desc: "Annual visits to top Nordic financial institutions in Stockholm and beyond.",
    image: carnegie,
    link: "/activities?tab=archive#event-banking-trip",
  },
  {
    title: "Trading & Workshops",
    desc: "Hands-on skill development sessions on valuation, modeling and market dynamics.",
    image: tradingWorkshop,
    link: "/activities?tab=archive#event-trading-workshop",
  },
];

const DivisionsGrid = () => {
  return (
    <section className="py-24 md:py-32 bg-navy-dark text-paper">
      <div className="px-6 md:px-12 lg:px-24 max-w-7xl mx-auto">
        <div className="mb-16 md:mb-20">
          <span className="text-steel-light uppercase tracking-[0.3em] text-[10px] font-bold mb-4 block">
            Our Structure
          </span>
          <h2 className="font-serif text-4xl lg:text-5xl text-paper mb-4">
            The Committee
          </h2>
          <p className="text-steel-light font-medium">
            Specialized divisions driving our organization forward.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10 lg:gap-12">
          {divisions.map((d) => (
            <Link key={d.title} to={d.link} className="group cursor-pointer">
              <div className="aspect-[4/5] overflow-hidden mb-6 bg-navy">
                <img
                  src={d.image}
                  alt={d.title}
                  className="w-full h-full object-cover opacity-70 group-hover:opacity-100 group-hover:scale-105 transition-all duration-700"
                  loading="lazy"
                  decoding="async"
                />
              </div>
              <h3 className="font-serif text-2xl text-paper mb-3 group-hover:text-steel-light transition-colors">
                {d.title}
              </h3>
              <p className="text-paper/50 text-sm leading-relaxed">{d.desc}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default DivisionsGrid;
